import { render } from "./study.vue?vue&type=template&id=183ceaa6&scoped=true"
import script from "./studyComponent.js?vue&type=script&lang=js"
export * from "./studyComponent.js?vue&type=script&lang=js"

import "./study.vue?vue&type=style&index=0&id=183ceaa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183ceaa6"]])

export default __exports__